module.exports = __webpack_public_path__ + "static/media/try-new-ru.92f21454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/jacktop-games/try-new-ru.png
// module id = 908
// module chunks = 7